
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import {Getter} from "vuex-class";
import { formRules } from "@/utils/formRules";
import { BADGE_PROVIDERS, BADGE_TYPES, ORDER_TYPES } from "@/utils/buildingOrders";
import MylobyAutocomplete from "../generic/autocomplete.vue";

@Component({
  components: {
    formRules, MylobyAutocomplete,
  },
})
export default class BuildingOrderModal extends Vue {

    @Prop({ default: false })
    public displayModal: boolean;

    @Prop({default: null})
    public building: any;

    private rules = formRules;
    private valid: boolean = true;
    private loadingOrderCreation: boolean = false;
    private loadingGetPricing: boolean = false;
    private BADGE_TYPES = Object.values(BADGE_TYPES).map((type) => ({
        text: this.$t(`Badges.types.${type}`),
        value: type,
    }));
    private BADGE_PROVIDERS = Object.values(BADGE_PROVIDERS).map((type) => ({
        text: this.$t(`Badges.providers.${type}`),
        value: type,
    }));
    private ORDER_TYPES = Object.values(ORDER_TYPES).map((type) => ({
        text: this.$t(`Badges.orderTypes.${type}`),
        value: type,
    }));
    private headers = [
        { text: this.$t("Badges.type"), value: "type", sortable: false },
        { text: this.$t("Badges.price"), value: "price", sortable: false },
    ];
    private pricing = [];
    private badgeData: {
        provider: BADGE_PROVIDERS,
        holderEmail: string,
        holderName: string,
        holderFirstName: string,
        lotId: string,
        quantity: number,
        itemType: BADGE_TYPES,
        referenceBadgeId: string,
        orderType: string,
    } = {
        provider: BADGE_PROVIDERS.URMET,
        holderEmail: "",
        holderName: "",
        holderFirstName: "",
        lotId : "",
        quantity : 1,
        itemType: BADGE_TYPES.BADGE,
        referenceBadgeId : "",
        orderType: "",
    };

    get creation() { return this.badgeData.orderType === "CREATION"; }

    private lots = [];

    @Getter private currentUser: any;
    @Getter private isMobile: boolean;

    @Watch("displayModal")
    public handlerShow(val) {
        if (val) {
            this.getPricing();
        }
    }

    private createBuildingOrder() {
        this.loadingOrderCreation = true;
        this.$store.dispatch("buildings/createOrder", {
            buildingId: this.building.id,
            orderData: {
              ...this.badgeData,
              buildingId: this.building.id,
            },
        })
        .then((res) => {
            this.$store.commit("alerts/displaySuccess", {
              msg: this.$i18n?.t("Badges.creation.success"),
            });
            this.$emit("success");
            this.$emit("close");
        })
        .catch((error) => {
            this.$store.commit("alerts/displayHttpError", { error });
        })
        .finally(() => {
          this.loadingOrderCreation = false;
        });
    }

    private getPricing() {
        this.loadingGetPricing = true;
        this.$store.dispatch("buildingOrders/getPricing",
        )
        .then((res) => {
            this.pricing = res;
        })
        .catch((error) => {
            this.$store.commit("alerts/displayHttpError", { error });
        })
        .finally(() => {
            this.loadingGetPricing = false;
        });
    }

    private close(): void {
        this.$emit("close");
    }
}
